import { BaseIcon } from "@dgs/core";
import styled from "styled-components";

export const ChoiceButton = styled.button`
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 5px;
	color: ${({ theme }) => theme.colors.palette.grey[80]};
	background: ${({ theme }) => theme.colors.palette.content.dark.base};
	padding: ${({ theme }) => theme.spacing(5)};

	&[aria-pressed="true"] {
		color: ${({ theme }) => theme.colors.palette.black};
		background: ${({ theme }) => theme.colors.palette.grey[20]};
	}
`;

export const ChoiceButtonGroup = styled.div`
	display: grid;
	grid-auto-flow: column;
	grid-auto-columns: 1fr;
	gap: ${({ theme }) => theme.spacing(2)};
`;

export const ChoiceButtonBaseIcon = styled(BaseIcon)`
	height: 40px;
	width: 40px;
	align-self: center;
	justify-self: center;
`;
